<template>
    <div class="wrapper">
        <app-header></app-header> <hr>
        <app-documents-library></app-documents-library>
        <app-footer></app-footer>
    </div>
</template>
<script>
    import Header from '@/components/layout/NewHeader'
    import Footer from '@/components/layout/NewFooter'

    import DocumentLibraryBlock from './DocumentsLibraryBlock'

    export default {
        components: {
            'app-header': Header,
            'app-footer': Footer,
            'app-documents-library': DocumentLibraryBlock,
        }
    }
</script>
<style lang="scss" scoped>
    .wrapper {
        width: 100%;
    }
</style>